<div [ngClass]="isTestActive ? 'test-account-header' : 'account-header'">
  <div style="justify-content: start; width: 100%; position: relative;" class="flex align-items-center h-full gap-10">
    <div class="flex gap-10 align-items-center h-full">
      <div [ngClass]="isTestActive ? 'version test-version' : 'version'" class="version">
        <p [ngClass]="isTestActive ? 'dark-blue' : 'yellow'" class="no-margin text-sm"><span
            class="text-xs">Version</span><br>{{version}}</p>
      </div>
    </div>
    <div *ngIf="(firstname != 'New' && lastname != 'Voter') &&
            (firstname != null); else emailBlock" class="flex align-items-center">
      <p [ngClass]="isTestActive ? 'dark-blue' : 'white'" class="no-margin">{{firstname}} {{lastname}}</p>
    </div>
    <ng-template #emailBlock>
      <div class="headband">
        <p [ngClass]="isTestActive ? 'dark-blue' : 'white'" class="no-margin text-xs" *ngIf="!isClose">{{email}}</p>
      </div>
    </ng-template>
    <div *ngIf="canHaveTestMode" [ngClass]="{ 'pointer': isValidated, 'display-none': !isValidated, 'bg-light-blue': !isTestActive, 'bg-yellow': isTestActive}"
      class="h-full text-center test-wrapper" (click)="isValidated && activateTestVersion()">
      <p *ngIf="!isTestActive" class="no-margin white"><span class="play-triangle-yellow"></span>Accéder à l'espace de test
      </p>
      <p *ngIf="isTestActive" class="no-margin dark-blue"><span class="play-triangle"></span>Quitter l'espace de test
      </p>
    </div>
  </div>

  <span class="right-container">
    <div class="flex align-items-center gap-10">
      <p class="banner-text text-sm">
        {{accountName}}
      </p>
    </div>

  </span>
</div>
